function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme, _ref) {
  var getColor = _ref.getColor;
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          color = _ref2.color,
          isChecked = _ref2.isChecked,
          __internal__keyboardFocus = _ref2.__internal__keyboardFocus;

      switch (targetElement) {
        case "container":
          {
            return {
              display: "flex",
              flexDirection: "column",
              flex: 1
            };
          }

        case "input":
          {
            return _objectSpread(_objectSpread({}, theme.focusStyles.focusVisibleAdjacentLabel), {}, {
              ":checked + label": {
                backgroundColor: theme.colors.secondary.lightBlue.t25,
                color: theme.colors.primary.blue.t100
              }
            });
          }

        case "label":
          {
            return _objectSpread({
              display: "inline-flex",
              alignItems: "flex-start",
              padding: "".concat(theme.space[3], " ").concat(theme.space[4]),
              minHeight: "24px",
              fontSize: theme.fontSizes[1],
              fontWeight: theme.fontWeights.light,
              lineHeight: theme.lineHeights[2],
              fontFamily: theme.fonts.body,
              color: theme.colors.black,
              backgroundColor: getColor(color),
              borderRadius: theme.radii[0]
            }, __internal__keyboardFocus && theme.focusStyles.__keyboardFocusAdjacentLabel);
          }

        case "svg":
          {
            return {
              flexShrink: 0,
              width: "24px",
              height: "24px",
              marginRight: theme.space[3]
            };
          }

        case "svgRect":
          {
            return {
              fill: getColor(color === "grey.t05" || isChecked ? "white" : "secondary.lightBlue.t25")
            };
          }

        case "svgPath":
          {
            return {
              stroke: theme.colors.primary.blue.t100
            };
          }

        default:
          {
            return null;
          }
      }
    }
  };
});